import api from "./axios";

export const getPricingPolicy = () => api.get("/pricing/policy");
export const updatePricingPolicy = (data) => api.patch("/pricing/policy", data);
export const previewPricing = (items, options = {}) => api.post(
  "/pricing/preview",
  { items, pricing_mode: options.pricingMode || "RETAIL" },
  { signal: options.signal },
);
